import { useEffect } from "react";

export default function useSeo({ title, description, image, canonical, noindex } = {}) {
  useEffect(() => {
    if (title) document.title = title;
    const set = (selector, attr, value) => {
      if (!value) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [, key, val] = selector.match(/\[(.+?)="(.+?)"\]/) || [];
        if (key) el.setAttribute(key, val);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };
    set('meta[name="description"]', "content", description);
    set('meta[property="og:title"]', "content", title);
    set('meta[property="og:description"]', "content", description);
    set('meta[property="og:type"]', "content", "website");
    if (image) set('meta[property="og:image"]', "content", image);
    set('meta[name="robots"]', "content", noindex ? "noindex,nofollow" : "index,follow");

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical || window.location.href);
  }, [title, description, image, canonical, noindex]);
}
